export default {"src":"/_next/static/media/ic-computer.13af0fff.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};